<script setup lang="ts">
import { EMPTY_FIELD_SIGN } from '../utils.ts';
import Markdown from '@/components/Markdown/Markdown.vue';

export interface FormInputDisplayProps {
  value?: string | null;
  useMarkdown?: boolean;
  maxRows?: number;
  placeholder?: string;
  suffix?: string;
  prefix?: string;
}

defineProps<FormInputDisplayProps>();
</script>

<template>
  <div
    data-testid="FormInputDisplay"
    :style="`max-height: ${maxRows ?? 10}em`"
    class="form-input-display overflow-y-auto"
  >
    <div v-if="prefix" class="d-inline">{{ prefix }}:&nbsp;</div>

    <div :class="$attrs.class" class="d-inline">
      <span v-if="!value" class="text-primary-lighten-2 font-weight-semibold">
        {{ placeholder ?? EMPTY_FIELD_SIGN }}
      </span>

      <Markdown v-else-if="useMarkdown" :value="value" />

      <template v-else>{{ value }}</template>
    </div>

    <div v-if="suffix" class="suffix d-inline">&nbsp;{{ suffix }}</div>
  </div>
</template>

<style lang="scss" scoped>
.form-input-display {
  white-space: pre-wrap;
}
</style>
